import React from 'react'
import Moment from 'moment'
import 'moment/locale/uk'

Moment.locale('uk')

class ScheduleDates extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      select_open: false,
    }
    this.handleDateClick = this.handleDateClick.bind(this)
    this.toggleSelect = this.toggleSelect.bind(this)
    this.closeSelect = this.closeSelect.bind(this)
  }
  handleDateClick(date) {
    this.props.setDate(date)
  }
  getClassName() {
    let open = this.state.select_open ? " open" : ""
    if (this.props.dates.indexOf(this.props.currentDate) > 5) {
      open += " selected"
    }
    return "date_select"+open
  }
  toggleSelect() {
    this.setState(prevState => ({
      select_open: !prevState.select_open
    }))
    if (!this.state.select_open) {
      document.addEventListener("click", this.closeSelect, false)
    } else {
      document.removeEventListener("click", this.closeSelect, false)
    }
  }
  closeSelect(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.setState({select_open: false})
  }
  render () {
    return (
      <ul className="schedule__dates">
        {
          this.props.dates.map(date =>
            <li className={date === this.props.currentDate ? "selected" : undefined} key={date} onClick={() => this.handleDateClick(date)}>
              {Moment.utc(date).format("D MMMM, ddd")}
            </li>    
          )
        }
        {
          this.props.dates.length > 6 &&
          <li className={this.getClassName()} onClick={() => {this.toggleSelect()}} ref={node => {this.node = node}}>
            {this.props.dates.indexOf(this.props.currentDate) > 5 ? Moment.utc(this.props.currentDate).format("D MMMM, ddd") : "Обери дату"} <img src="/img/ic_select.svg" alt="" />
            <ul className="select__options">
            {
              this.props.dates.map((date, index) => 
                index > 5 &&
                <li className="select__option" key={date} onClick={() => this.handleDateClick(date)}>
                  {Moment.utc(date).format("D MMMM, ddd")}
                </li>    
              )
            }
            </ul>
          </li>
        }
      </ul>
    )
  }
}

export default ScheduleDates


// WEBPACK FOOTER //
// ./src/components/snippets/ScheduleDates.jsx